// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pedidos_container__VQpO1 {
  padding: 2rem;
}

.Pedidos_title__7xjeJ {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}

.Pedidos_tableContainer__2ewdQ {
  margin-top: 1rem;
}

.Pedidos_statusChip__Jk3tr {
  font-weight: 500;
}




`, "",{"version":3,"sources":["webpack://./src/components/Pages/Pedidos/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".container {\n  padding: 2rem;\n}\n\n.title {\n  display: flex;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.tableContainer {\n  margin-top: 1rem;\n}\n\n.statusChip {\n  font-weight: 500;\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Pedidos_container__VQpO1`,
	"title": `Pedidos_title__7xjeJ`,
	"tableContainer": `Pedidos_tableContainer__2ewdQ`,
	"statusChip": `Pedidos_statusChip__Jk3tr`
};
export default ___CSS_LOADER_EXPORT___;
